import styled from 'styled-components';
import { BasicButton } from '../../../component/button';
import { colors } from '../../../component/colors';
import { pxToRem } from '../../../utils/pxToRem';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 120px;
`;
export const Title = styled.p`
  font-family: DM Sans;
  font-size: ${pxToRem(21)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(29)};
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;
export const AddPromotionBtn = styled(BasicButton)`
  width: 120px;
  padding: 11px 0px;
  border-radius: 8px;
`;
export const SortContainer = styled.div`
  align-self: flex-end;
  display: flex;
  align-items: center;
  margin-top: 61px;
`;
export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 8px;
  margin-right: 24px;
  width: 280px;
  height: 32px;

  /* Colors/Primary/Tints/50% */

  background: #ffffff;
  border-radius: 8px;
`;
export const SearchIcon = styled.img``;

export const SearchBar = styled.input`
  background-color: #ffffff;
  border: none;
  outline: none;

  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(21)};
  letter-spacing: 0.1px;
  color: #a1a1a1;
  &::placeholder {
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 400;
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(21)};
    letter-spacing: 0.1px;
    color: #a1a1a1;
  }
`;

export const SortText = styled(Title)`
  margin-right: 16px;
`;
export const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 48px;
`;
export const PageSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const PageButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;

  :hover {
    opacity: 0.6;
    cursor: pointer;
  }
`;
export const PrevIcon = styled.img``;
export const NextIcon = styled.img``;
export const PageItems = styled.span<{ isActive: boolean }>`
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(16)};
  padding: 6px 12px;
  cursor: pointer;
  color: ${({ isActive }) => (isActive ? '#F4F5F7' : '#42526E')};
  background-color: ${({ isActive }) =>
    isActive ? colors.sojiOrange : 'transparent'};
`;
